import { createFileRoute } from "@tanstack/react-router";
import { PublicStoryViewer } from "../../components/PublicStoryViewer";
import { apiClient } from "../../lib/api";

export const Route = createFileRoute("/_layout/story/share/$token")({
    loader: async ({ params }) => {
        try {
            const storyData = await apiClient.getSharedStory(params.token);
            return { storyData };
        } catch {
            // If story fails to load, return null and let component handle error state
            return { storyData: null };
        }
    },
    head: ({ loaderData, params }) => {
        const { storyData } = loaderData || {};

        // Dynamic meta data based on actual story
        const title = storyData?.story?.title || storyData?.story?.topic || "A StoryDoodle Adventure";
        const description = `Check out "${title}" - a creative story made with StoryDoodle where drawings come to life through AI!`;

        // Construct thumbnail URL for og:image
        const thumbnailUrl = `${window.location.origin}/api/public/story/share/${params.token}/thumbnail`;

        return {
            meta: [
                { property: "og:title", content: title },
                { property: "og:description", content: description },
                { property: "og:type", content: "article" },
                { property: "og:site_name", content: "StoryDoodle" },
                { property: "og:image", content: thumbnailUrl },
                { property: "og:image:width", content: "400" },
                { property: "og:image:height", content: "300" },
                { property: "twitter:card", content: "summary_large_image" },
                { property: "twitter:title", content: title },
                { property: "twitter:description", content: description },
                { property: "twitter:image", content: thumbnailUrl },
                {
                    name: "description",
                    content: description,
                },
            ],
        };
    },
    component: SharedStoryPage,
});

function SharedStoryPage() {
    const { storyData } = Route.useLoaderData();

    return (
        <div className="min-h-screen page-gradient">
            <PublicStoryViewer storyData={storyData} />
        </div>
    );
}
